'use client';

import {
  faArrowUp,
  faMicrophone,
  faSpinner,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslations } from 'use-intl';

import { ProjectResponseSendComponentProps } from './project-response-renderer.type';
import { useProjectResponseSend } from './project-response-send.hooks';

export default function ProjectResponseSelectSendButtonMobile({
  disabled,
  isSubmitting,
  renderMobileView,
  type,
  isUserVoiceEnabled,
}: ProjectResponseSendComponentProps) {
  const t = useTranslations('Chat');

  const { handleToggle } = useProjectResponseSend(type);
  return (
    <div
      className='flex flex-1 items-center gap-2 sm:hidden'
      data-state={renderMobileView ? 'mobile' : 'desktop'}
      data-test='select-send-button-mobile'
    >
      {isUserVoiceEnabled && (
        <button
          onClick={handleToggle}
          type='button'
          className='inline-flex items-center justify-center gap-2 rounded-full bg-gray-100 px-3 py-2 text-black transition-colors hover:bg-gray-200'
          data-test='select-voice-button-mobile'
        >
          <FontAwesomeIcon icon={faMicrophone} className='size-4 text-black' />
          <span className='[font-family:var(--brand-font)] text-xs font-medium text-black'>
            {t('voice')}
          </span>
        </button>
      )}
      <button
        disabled={disabled}
        className='h-8 w-full flex-1 items-center justify-center gap-2 rounded-full bg-(--brand-primary) px-3 py-2 transition-all disabled:opacity-20'
        data-test='select-send-button-mobile-btn'
      >
        {isSubmitting ? (
          <FontAwesomeIcon
            icon={faSpinner}
            className='relative size-6 animate-spin text-(--brand-primary-contrast)'
          />
        ) : (
          <div className='flex flex-nowrap items-center justify-center gap-2 text-center'>
            <FontAwesomeIcon
              icon={faArrowUp}
              className='relative h-3 w-2.5 text-(--brand-primary-contrast)'
            />
            <span className='block text-center [font-family:var(--brand-font)] text-xs font-medium text-(--brand-primary-contrast)'>
              {t('send')}
            </span>
          </div>
        )}
      </button>
    </div>
  );
}
